// Set display (grid or list)
// eslint-disable-next-line import/prefer-default-export
export function setDisplay(payload) {
  return { type: 'display:store', payload };
}
